import { format, formatDistanceToNow, getTime } from 'date-fns';

// ----------------------------------------------------------------------

type InputValue = Date | null | number | string;

export const fDate = (date: InputValue, newFormat?: string) => {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
};

export const fDateTime = (date: InputValue, newFormat?: string) => {
  const fm = newFormat || 'dd MMM yyyy p';

  return date ? format(new Date(date), fm) : '';
};

export const fTimestamp = (date: InputValue) => {
  return date ? getTime(new Date(date)) : '';
};

export const fToNow = (date: InputValue) => {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
};

export const fJoinedDate = (date: string) => {
  const dateUnits = date.split('-');
  return `${dateUnits[2]} ${getMonthName(Number(dateUnits[1]))} ${
    dateUnits[0]
  }`;
};

// ----------------------------------------------------------------------

const getMonthName = (monthNumber: number) => {
  const date = new Date();
  date.setMonth(monthNumber - 1);

  return date.toLocaleString('en-US', {
    month: 'short',
  });
};
